// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__1l_ya","label":"Completed_label__1SifR"};